export const regionOptions = [
    {
        "en": "North (Yukon, Northwest Territories, Nunavut)",
        "fr": "Nord (Yukon, Territoires du Nord-Ouest, Nunavut)"
    },
    {
        "en": "West (British-Columbia, Alberta, Saskatchewan, Manitoba)",
        "fr": "Ouest (Colombie-Britannique, Alberta, Saskatchewan, Manitoba)"
    },
    {
        "en": "Central - ON (Ontario)",
        "fr": "Centre (Ontario)"
    },
    {
        "en": "Central - QC (Québec)",
        "fr": "Centre (Québec)"
    },
    {
        "en": "East (Nova-Scotia, New Brunswick, Prince-Edward Island, Newfoundland and Labrador)",
        "fr": "Est (Nouvelle-Écosse, Nouveau-Brunswick, Île-du-Prince-Édouard, Terre-Neuve-et-Labrador)"
    },
    {
        "en": "Outside of Canada",
        "fr": "En dehors du Canada"
    }
]

export const studentDegrees = [
    { en: "Master's 1", fr: "Étudiant·e en maîtrise 1"},
    { en: "Master's 2", fr: "Étudiant·e en maîtrise 2"},
    { en: "PhD 1", fr: "Doctorant·e 1"},
    { en: "PhD 2", fr: "Doctorant·e 2"},
    { en: "PhD 3", fr: "Doctorant·e 3"},
    { en: "PhD 4+", fr: "Doctorant·e 4+"},
    { en: "Postdoctoral Fellow 1", fr: "Chercheur·euse postordoctral·e 1"},
    { en: "Postdoctoral Fellow 2", fr: "Chercheur·euse postordoctral·e 2"},
    { en: "Early Career Researcher 1", fr: "Chercheur·euse en début de carrière 1"},
    { en: "Early Career Researcher 2", fr: "Chercheur·euse en début de carrière 2"},
    { en: "Early Career Researcher 3", fr: "Chercheur·euse en début de carrière 3"},
    { en: "Early Career Researcher 4", fr: "Chercheur·euse en début de carrière 4"},
    { en: "Early Career Researcher 5+", fr: "Chercheur·euse en début de carrière 5+"},
]

export const disciplineOptions = [
    { en: "Psychology", fr: "Psychologie"},
    { en: "Social Work", fr: "Travail Social"},
    { en: "Nursing", fr: "Allaitement"},
    { en: "Medicine", fr: "Médecine"},
    { en: "Rehabilitation Sciences", fr: "Sciences de la Réadaptation"},
    { en: "Computer Sciences", fr: "Sciences Informatiques"},
    { en: "Other", fr: "Autre"},
]
